import React, { useState } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, Button, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

const UploadBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const OptionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  width: '100%',
  padding: theme.spacing(2),
}));

const GpxUploader = () => {
  const [open, setOpen] = useState(false);
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleUploadClick = () => {
    setUploadDialogOpen(true);
    setOpen(false);
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && file.name.toLowerCase().endsWith('.gpx')) {
      setSelectedFile(file);
    } else {
      alert('Please select a GPX file');
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('gpx', selectedFile);

    try {
      const response = await axios.post(`${process.env.REACT_APP_VALHALLA_URL_BACKEND}/api/mapmatching/uploadgpx`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.id) {
        // Redirigir a la vista del mapa con el ID
        window.location.href = `/view/${response.data.id}`;
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Error uploading file');
    }
  };

  return (
    <>
      <Button onClick={handleOpen} variant="contained" color="primary">
        Choose GPS Data Source
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <DialogTitle>
          Choose a source of GPS data
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <OptionContainer>
            <UploadBox onClick={handleUploadClick}>
              <CloudUploadIcon sx={{ fontSize: 60, mb: 1 }} />
              <Typography variant="subtitle1">Upload your GPX logfile</Typography>
              <Typography variant="caption" color="textSecondary">
                (privacy policy)
              </Typography>
            </UploadBox>
          </OptionContainer>
        </DialogContent>
      </Dialog>

      <Dialog open={uploadDialogOpen} onClose={() => setUploadDialogOpen(false)}>
        <DialogTitle>
          Select a GPX file
          <IconButton
            aria-label="close"
            onClick={() => setUploadDialogOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <input
              type="file"
              accept=".gpx"
              onChange={handleFileSelect}
              style={{ marginBottom: 16 }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
              <Button onClick={() => setUploadDialogOpen(false)}>Cancel</Button>
              <Button
                onClick={handleUpload}
                variant="contained"
                color="primary"
                disabled={!selectedFile}
              >
                Run map-matching
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GpxUploader; 